import { NavLink, Outlet } from 'react-router-dom';
import { Building2, LayoutGrid, Receipt, FileText, Target, UserRound, Users2, Wallet } from 'lucide-react';
import { usePermission } from '@/hooks/usePermission';

interface Tab {
  to: string;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
  end?: boolean;
  permission?: string;
}

const tabs: Tab[] = [
  { to: '/crm', label: 'Dashboard', icon: LayoutGrid, end: true },
  { to: '/crm/leads', label: 'Leads', icon: Target },
  { to: '/crm/companies', label: 'Companies', icon: Building2 },
  { to: '/crm/contacts', label: 'Contacts', icon: UserRound },
  { to: '/crm/deals', label: 'Deals', icon: Users2 },
  { to: '/crm/quotations', label: 'Quotations', icon: Receipt },
  { to: '/crm/proposals', label: 'Proposals', icon: FileText },
  { to: '/crm/invoices', label: 'Invoices', icon: Wallet },
];

export function CrmLayout() {
  return (
    <div className="flex flex-col gap-5">
      <div>
        <h1 className="text-xl font-semibold text-gray-900 dark:text-gray-100">CRM</h1>
        <p className="mt-0.5 text-sm text-gray-500 dark:text-gray-400">Leads, companies, contacts, deals, and the sales pipeline.</p>
      </div>

      <div className="-mb-px flex gap-1 overflow-x-auto border-b border-gray-200 dark:border-gray-800">
        {tabs.map((tab) => (
          <TabLink key={tab.to} tab={tab} />
        ))}
      </div>

      <Outlet />
    </div>
  );
}

function TabLink({ tab }: { tab: Tab }) {
  const allowed = usePermission(tab.permission ?? '__always__') || !tab.permission;
  if (!allowed) {
    return null;
  }

  return (
    <NavLink
      to={tab.to}
      end={tab.end}
      className={({ isActive }) =>
        `flex shrink-0 items-center gap-1.5 border-b-2 px-3 py-2.5 text-sm font-medium transition-colors ${
          isActive
            ? 'border-brand-600 text-brand-700 dark:border-brand-400 dark:text-brand-300'
            : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200'
        }`
      }
    >
      <tab.icon className="h-4 w-4" />
      {tab.label}
    </NavLink>
  );
}
